import type { OrderRecognitionRuleRepository } from "../../../domain/repositories/company/order-recognition-rule-repository";
import { orderRecognitionRuleApiService } from "../../api/company/order-recognition-rule-api-service";
import type {
  OrderRecognitionRule,
  CustomerEmailItem,
  CustomerSuggestion,
  SaveOrderRecognitionRuleRequest,
  AddCustomerEmailRequest,
} from "../../../domain/types/order-recognition-rule";

export class OrderRecognitionRuleRepositoryImpl
  implements OrderRecognitionRuleRepository
{
  async getRule(companyId: number): Promise<OrderRecognitionRule> {
    const response = await orderRecognitionRuleApiService.getRule(companyId);

    if (!response.data) {
      throw new Error(
        response.errorMsg || "주문 인식 규칙을 불러오지 못했습니다.",
      );
    }

    return response.data;
  }

  async saveRule(
    companyId: number,
    request: SaveOrderRecognitionRuleRequest,
  ): Promise<OrderRecognitionRule> {
    const response = await orderRecognitionRuleApiService.saveRule(
      companyId,
      request,
    );

    if (!response.data) {
      throw new Error(
        response.errorMsg || "주문 인식 규칙 저장에 실패했습니다.",
      );
    }

    return response.data;
  }

  async getCustomerEmails(companyId: number): Promise<CustomerEmailItem[]> {
    const response =
      await orderRecognitionRuleApiService.getCustomerEmails(companyId);
    return response.data ?? [];
  }

  async addCustomerEmail(
    companyId: number,
    request: AddCustomerEmailRequest,
  ): Promise<CustomerEmailItem> {
    const response = await orderRecognitionRuleApiService.addCustomerEmail(
      companyId,
      request,
    );

    if (!response.data) {
      throw new Error(
        response.errorMsg || "등록 고객 메일 추가에 실패했습니다.",
      );
    }

    return response.data;
  }

  async deleteCustomerEmail(companyId: number, id: number): Promise<void> {
    await orderRecognitionRuleApiService.deleteCustomerEmail(companyId, id);
  }

  async suggestCustomerEmails(
    companyId: number,
    email: string,
  ): Promise<CustomerSuggestion[]> {
    const response =
      await orderRecognitionRuleApiService.suggestCustomerEmails(
        companyId,
        email,
      );
    return response.data ?? [];
  }
}
